import type { IconSvgObject } from './types';

const MessageCircleReplyIcon: IconSvgObject = [
  ["path", { d: "M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C10.3719 21.5 8.8394 21.0904 7.5 20.3687C5.5 19.5 3.5 19.9125 2.5 20C2.98894 19.1667 3.60922 16.8818 2.98341 15C2.6698 14.057 2.5 13.0483 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10.5 8.5L7.5 11.5L10.5 14.5M8 11.5H14.5C15.6046 11.5 16.5 12.3954 16.5 13.5V14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default MessageCircleReplyIcon;
